import { useEffect } from 'react';
import { useTheme as useReduxTheme } from '@/hooks';

/**
 * ThemeProvider component that syncs Redux theme state to the HTML element's data-theme attribute.
 * This allows CSS variables to switch between light and dark themes.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useReduxTheme();

  useEffect(() => {
    const root = document.documentElement;
    
    // Apply theme attribute to HTML element
    if (theme === 'dark') {
      root.setAttribute('data-theme', 'dark');
    } else {
      root.setAttribute('data-theme', 'light');
    }
  }, [theme]);

  // Also apply theme on initial mount (in case Redux state hasn't synced yet)
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null;
    const initialTheme = savedTheme || 
      (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    
    const root = document.documentElement;
    root.setAttribute('data-theme', initialTheme);
  }, []);

  return <>{children}</>;
}

